"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var shouldUseFlex = function shouldUseFlex(props) {
  return props.flex || Object.keys(props).map(function (item) {
    return !(item === "children" || item === "spaceAfter" || item === "spacing" || item === "dataTest");
  }).indexOf(true) !== -1;
};

var _default = shouldUseFlex;
exports.default = _default;